import {
	SET_LABOR_RATES,
	ADD_SELECTED_LABOR_CODE,
	REMOVE_SELECTED_LABOR_CODE,
	SET_SELECTED_DEFECT_CODE,
	RESET_LABOR_RATES
} from './honda-flat-rate-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import gatherItems from '@/utils/gather-items';
import Vue from 'vue';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'hondaFlatRate',
	namespaced: true,
	state: {
		laborRates: {},
		selectedDefectCode: undefined,
		selectedLaborCodes: [],
		laborRatesTotalCount: 0
	},
	mutations: {
		[SET_LABOR_RATES](state, laborRates) {
			Vue.set(state.laborRates, laborRates.page + '', laborRates);
		},
		[ADD_SELECTED_LABOR_CODE](state, laborCode) {
			state.selectedLaborCodes.push(laborCode);
		},
		[REMOVE_SELECTED_LABOR_CODE](state, id) {
			const index = state.selectedLaborCodes.findIndex(
				code => code.id === id
			);

			if (index >= 0) {
				state.selectedLaborCodes.splice(index, 1);
			}
		},
		[SET_SELECTED_DEFECT_CODE](state, laborCode) {
			state.selectedDefectCode = laborCode;
		},
		[RESET_LABOR_RATES](state) {
			// for (const key in state) {
			Vue.set(state, 'laborRates', {});
			// }
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
		async getLaborRatesAction({ commit }, parameters) {
			let laborRates = await api.get(
				buildRoute('/oem/honda/flatrates', { query: parameters })
			);

			commit(SET_LABOR_RATES, laborRates);
		},
		addLaborCodeAction({ commit }, laborCode) {
			commit(ADD_SELECTED_LABOR_CODE, laborCode);
		},
		removeLaborCodeAction({ commit }, id) {
			commit(REMOVE_SELECTED_LABOR_CODE, id);
		},
		setDefectCodeAction({ commit }, defectCode) {
			commit(SET_SELECTED_DEFECT_CODE, defectCode);
		},
		resetLaborRatesAction({ commit }) {
			commit(RESET_LABOR_RATES);
		}
	},
	getters: {
		laborRates: state => state.laborRates,
		selectedDefectCode: state => state.selectedDefectCode,
		selectedLaborCodes: state => state.selectedLaborCodes,
		selectedOpCodes: state => {
			if (state.selectedLaborCodes.length === 0) {
				return [
					{
						id: 0,
						defectCode: state.selectedDefectCode || null,
						OpCode: '',
						Hours: '',
						Description: ''
					}
				];
			} else {
				return state.selectedLaborCodes.map(laborCode => {
					return {
						id: laborCode.id,
						defectCode: state.selectedDefectCode,
						OpCode: laborCode.laborOpNumber,
						Hours: laborCode.flatRateTime.toString(),
						Description: laborCode.description
					};
				});
			}
		},
		laborRatesTotalCount: state => {
			let count = 0;

			if (state.laborRates && state.laborRates[1]) {
				count = state.laborRates[1].totalCount;
			}

			return count;
		},
		laborRatesItems: state => {
			const items = gatherItems(state.laborRates);
			return items;
		}
	}
};
